//import modules
import IPCFetch from './IPCFetch';

export default IPCFetch;
